const LOCAL_RUNTIME_HOSTNAMES = new Set(["localhost", "127.0.0.1", "::1"]);

const firebaseEnvValues = {
  VUE_APP_FIRESTORE_API_KEY: import.meta.env.VUE_APP_FIRESTORE_API_KEY ?? "",
  VUE_APP_FIRESTORE_AUTH_DOMAIN:
    import.meta.env.VUE_APP_FIRESTORE_AUTH_DOMAIN ?? "",
  VUE_APP_FIRESTORE_PROJECTID: import.meta.env.VUE_APP_FIRESTORE_PROJECTID ?? "",
  VUE_APP_FIRESTORE_STORAGE_BUCKET:
    import.meta.env.VUE_APP_FIRESTORE_STORAGE_BUCKET ?? "",
  VUE_APP_FIRESTORE_MESSAGING_SENDER_ID:
    import.meta.env.VUE_APP_FIRESTORE_MESSAGING_SENDER_ID ?? "",
  VUE_APP_FIRESTORE_APP_ID: import.meta.env.VUE_APP_FIRESTORE_APP_ID ?? "",
  VUE_APP_FIRESTORE_MEASUREMENT_ID:
    import.meta.env.VUE_APP_FIRESTORE_MEASUREMENT_ID ?? "",
};

const firebaseClientConfig = {
  apiKey: firebaseEnvValues.VUE_APP_FIRESTORE_API_KEY,
  authDomain: firebaseEnvValues.VUE_APP_FIRESTORE_AUTH_DOMAIN,
  projectId: firebaseEnvValues.VUE_APP_FIRESTORE_PROJECTID,
  storageBucket: firebaseEnvValues.VUE_APP_FIRESTORE_STORAGE_BUCKET,
  messagingSenderId: firebaseEnvValues.VUE_APP_FIRESTORE_MESSAGING_SENDER_ID,
  appId: firebaseEnvValues.VUE_APP_FIRESTORE_APP_ID,
  measurementId: firebaseEnvValues.VUE_APP_FIRESTORE_MEASUREMENT_ID,
};

const salesPrice = import.meta.env.VUE_APP_ONE_YEAR_PRICE ?? "";
const FIREBASE_EMULATOR_HOST = "127.0.0.1";
const FIREBASE_AUTH_EMULATOR_PORT = 9099;
const FIREBASE_FIRESTORE_EMULATOR_PORT = 8080;
const FIREBASE_FUNCTIONS_EMULATOR_PORT = 5001;
const FIRESTORE_FORCE_LONG_POLLING =
  String(import.meta.env.VUE_APP_FIRESTORE_FORCE_LONG_POLLING ?? "")
    .trim()
    .toLowerCase() === "true";
const FIRESTORE_DEBUG_TIMING =
  String(import.meta.env.VUE_APP_FIRESTORE_DEBUG_TIMING ?? "")
    .trim()
    .toLowerCase() === "true";

function isLocalhostRuntime(
  hostname = typeof location === "undefined" ? "" : location.hostname
) {
  return LOCAL_RUNTIME_HOSTNAMES.has(hostname);
}

function shouldUseFirebaseEmulators() {
  return isLocalhostRuntime();
}

function shouldEnableLocalDevFeatures() {
  return import.meta.env.DEV && shouldUseFirebaseEmulators();
}

function shouldForceFirestoreLongPolling() {
  return shouldUseFirebaseEmulators() && FIRESTORE_FORCE_LONG_POLLING;
}

function shouldLogFirestoreDebugTiming() {
  return FIRESTORE_DEBUG_TIMING;
}

function getMissingFirebaseConfigKeys() {
  return Object.entries(firebaseEnvValues)
    .filter(([, value]) => String(value).trim().length === 0)
    .map(([key]) => key);
}

function getPayPalClientId() {
  return import.meta.env.VUE_APP_PAYPAL_CLIENT_ID?.trim?.() ?? "";
}

export {
  FIREBASE_AUTH_EMULATOR_PORT,
  FIREBASE_EMULATOR_HOST,
  FIREBASE_FIRESTORE_EMULATOR_PORT,
  FIREBASE_FUNCTIONS_EMULATOR_PORT,
  firebaseClientConfig,
  getPayPalClientId,
  getMissingFirebaseConfigKeys,
  isLocalhostRuntime,
  salesPrice,
  shouldLogFirestoreDebugTiming,
  shouldEnableLocalDevFeatures,
  shouldForceFirestoreLongPolling,
  shouldUseFirebaseEmulators,
};
